<template>
  <div class="information-modal">
    <div
      class="modal-overlay"
    />

    <div class="submodal">
      <div class="header">
        {{ $t('analyses.standardOperators') }}
      </div>

      <div class="content">
        <ul class="information-list">
          <li>{{ $t('analyses.symbol') }}</li>
          <li>{{ $t('analyses.definition') }}</li>
          <li>+</li>
          <li>{{ $t('analyses.addition') }}</li>
          <li>-</li>
          <li>{{ $t('analyses.substraction') }}</li>
          <li>*</li>
          <li>{{ $t('analyses.multiplication') }}</li>
          <li>%</li>
          <li>{{ $t('analyses.division') }}</li>
          <li>()</li>
          <li>{{ $t('analyses.group') }}</li>
          <li><strong>.</strong></li>
          <li>{{ $t('analyses.decimal') }}</li>
        </ul>

        <div class="header">
          {{ $t('analyses.math') }}
        </div>

        <ul class="information-list">
          <li>abs(x)</li>
          <li>{{ $t('analyses.absoluteValue') }}</li>
          <li>log10(x)</li>
          <li>{{ $t('analyses.log10') }}</li>
          <li>ln(x)</li>
          <li>{{ $t('analyses.log') }}</li>
          <li>pow(x,y)</li>
          <li>{{ $t('analyses.pow') }}</li>
          <li>sin(x)</li>
          <li>{{ $t('analyses.sin') }}</li>
          <li>cos(x)</li>
          <li>{{ $t('analyses.cos') }}</li>
          <li>tan(x)</li>
          <li>{{ $t('analyses.tan') }}</li>
          <li>exp(x)</li>
          <li>{{ $t('analyses.exponent') }}</li>
          <li>sqrt(x)</li>
          <li>{{ $t('analyses.sqrt') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'InformationModal',
};
</script>

<style lang="scss" scoped>
.information-modal {
  position: absolute !important;

}
// Décaler la modale pour éviter qu'elle ne déborde à partir de la vue mobile large
@media screen and (max-width: 960px) {
  .information-modal {
    left: -300px;
    top: 80px;

  }
}

.submodal {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: 325px;
  box-shadow: 1px 1px 10px 1px;

  background: #FFF;
  z-index: 3;
}

.modal-overlay {
    position: fixed;

}
.header {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    padding: 12px;

    background: #26384B;
    color: #FFFFFF;
    font-weight: 400;
}

.content {
    width: 100%;
    overflow-y: auto;
}

.information-list {
 display: grid;
 grid-template-columns: repeat(2, 1.5fr);
 grid-auto-rows: minmax(30px, auto) ;

 width: 100%;
 color: #26384B;

}

.information-list li {
 display: flex;
 align-items: center;
 justify-content: center;

 width: 100%;
 font-size: 12px;

 border: 1px solid #26384B;
}

</style>

<style>
.submodal ::-webkit-scrollbar {
    width: 7px;
    border-radius: 50px;
}

.submodal ::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background: #9E9E9E;
}

.submodal ::-webkit-scrollbar-track {
    border-radius: 50px;
    background: #E1D5D5;
}

.submodal ::webkit-scrollbar-button {
    height: 6px;
}

.submodal ::-webkit-scrollbar {
    width: 7px;
    border-radius: 50px;
}

.submodal ::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background: #9E9E9E;
}
.submodal ::-webkit-scrollbar-track {
    background: #E1D5D5;
}
</style>
